import { Text, UnstyledButton, type UnstyledButtonProps } from '@mantine/core';
import { getLabel } from './helpers';
import type { Item } from './types';

export type SelectItemModalProps = UnstyledButtonProps & {
  item: Item;
  onClick: () => void;
  isSelected?: boolean;
  children?: React.ReactNode;
};

export const SelectItemModal: React.FC<SelectItemModalProps> = ({
  item,
  onClick,
  isSelected,
  children,
}) => (
  <UnstyledButton
    onClick={onClick}
    sx={theme => ({
      color: 'black',
      padding: '1rem',
      borderRadius: theme.other.borderRadius,
      background: isSelected ? theme.colors.violet[1] : 'transparent',
    })}
  >
    <Text fz="md">{getLabel(item)}</Text>
    {children}
  </UnstyledButton>
);
